import AddQuestionModal from './AddQuestionModal';

export default AddQuestionModal;
